import { array, struct } from 'io-ts/Decoder';

import { CountryCode } from '../../../../../country';

export const Request = struct({
	countryCodes: array(CountryCode),
});
